import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { EventDateAdd } from "./EventDateAdd";
import { EventDateList } from "./EventDateList";

function EventDatesCard(props) {
  const { t } = useTranslation();
  const [visibleDateAdd, setVisibleDateAdd] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const [mode, setMode] = useState("add");

  function toggleDialogAddDate() {
    setVisibleDateAdd(!visibleDateAdd);
  }
  return (
    <Fragment>
      {visibleDateAdd ? (
        <EventDateAdd
          toggleDialog={toggleDialogAddDate}
          title={mode === "add" ? t("add_date") : t("update_date")}
          event={props.event}
          setIsAdded={setIsAdded}
          isAdded={isAdded}
          mode={mode}
        ></EventDateAdd>
      ) : (
        ""
      )}
      <EventDateList
        event={props.event}
        toggleDialogAddDate={toggleDialogAddDate}
        setIsAdded={setIsAdded}
        isAdded={isAdded}
        setMode={setMode}
      ></EventDateList>
    </Fragment>
  );
}

export { EventDatesCard };
